/**
 * Un ítem se puede comprar si trae al menos un medio de pago habilitado. El backend ya resuelve
 * `habilitado` (cuenta corriente del comprador, cuenta de MP del vendedor) y el motivo en `tooltip`.
 * @param {{ mediosPagos?: Array<{ habilitado?: boolean }> }} item
 * @returns {boolean}
 */
export const tieneMedioPagoHabilitado = (item) =>
  Boolean(item?.mediosPagos?.some((mp) => mp.habilitado))

/**
 * Nombre visible de un medio de pago. El detalle lo trae anidado en `medioPago`; los endpoints
 * que devuelven el medio plano lo traen en `nombre` o `descripcion`.
 * @param {{ medioPago?: { nombre?: string }, nombre?: string, descripcion?: string }} mp
 * @returns {string}
 */
export const nombreMedioPago = (mp) =>
  mp?.medioPago?.nombre || mp?.nombre || mp?.descripcion || mp?.label || ''

/**
 * Opciones de react-select con los medios de pago habilitados de un ítem.
 * @param {Array} mediosPagos
 * @returns {Array<{ value: number, label: string }>}
 */
export const opcionesMedioPago = (mediosPagos = []) =>
  mediosPagos
    .filter((mp) => mp.habilitado)
    .map((mp) => ({ value: mp.idMedioPago, label: nombreMedioPago(mp) }))

/**
 * Los endpoints .NET (presupuestos) devuelven los medios de pago como ids en texto (`['1','3']`),
 * a diferencia de node que ya los devuelve resueltos. `true` si la lista viene en la forma vieja
 * y hay que normalizarla contra el catálogo.
 * @param {Array} mediosPagos
 * @returns {boolean}
 */
export const requiereNormalizarMediosPago = (mediosPagos) =>
  Boolean(mediosPagos?.some((mp) => mp !== null && typeof mp !== 'object'))

/**
 * Lleva los medios de pago en formato viejo (ids en texto) a la forma que devuelve node,
 * resolviendo el nombre contra el catálogo. Los que ya vienen resueltos pasan sin tocar, así el
 * consumidor no necesita saber de qué backend salieron.
 *
 * Los ids que no estén en el catálogo se descartan: el catálogo llega ya filtrado por la cuenta
 * corriente del comprador y la cuenta de Mercado Pago del vendedor.
 * @param {Array} mediosPagos ids en texto o medios ya resueltos
 * @param {Array<{ idMedioPago: number, nombre?: string }>} catalogo
 * @returns {Array<{ idMedioPago: number, habilitado: boolean, medioPago: object }>}
 */
export const normalizarMediosPago = (mediosPagos = [], catalogo = []) =>
  mediosPagos.flatMap((mp) => {
    if (mp !== null && typeof mp === 'object') return [mp]

    const idMedioPago = Number(mp)
    const medioPago = catalogo.find((c) => c.idMedioPago === idMedioPago)

    return medioPago ? [{ idMedioPago, habilitado: true, medioPago }] : []
  })
